import React, { useRef } from "react";
import { useSelector } from "react-redux";

import chatBackground from "img/chat-online-background.png";
import keycloak from "utils/keycloak";

import UserService from "services/user.service";
import KeycloakPubServiceInstance from "services/keycloakpubsub.service";

import { useMenuChatContext } from "contexts/MenuChat";

import "./styles.scss";

const Zenvia = () => {
  const customer = useSelector((state) => state.customer);
  const chat = useRef(null);
  const userService = new UserService();

  const bannerChatBot = useSelector((state) => state.eventsBanner);

  const { nutritionist, setNutritionist } = useMenuChatContext();

  function startZenvia(open) {
    KeycloakPubServiceInstance.subscribe(() => {
      userService.getZenviaToken().then((token) => {
        chat.current = window.altubots.sendDataToContext({
          nome: keycloak.profile.email,
          numeroDocumento: customer?.documentNumber || "",
          menu: nutritionist,
          ...Object.assign(
            ...token
              .match(/.{1,250}/g)
              .map((item, key) => ({ ["token_part" + key]: item }))
          ),
        });
      });

      if (open) {
        const idTimeout = window.setTimeout(() => {
          clearTimeout(idTimeout);
          openChatOk();
        }, 200);
      }
    });
  }

  async function openChatOk() {
    setNutritionist("");
    try {
      chat.current = window.altubots.openChat();
    } catch (ex) {
      window.location.reload();
    }
  }

  const viewBannerChatOnline = () => {
    if (bannerChatBot?.url_banner_chat_online)
      return bannerChatBot.url_banner_chat_online;

    return chatBackground;
  };

  return (
    <div className="fixed z-5 container-chat-bot">
      <div className="relative animated fadeIn faster">
        <img
          id="chat-bot"
          className="cursor-pointer"
          onClick={() => startZenvia(true)}
          src={viewBannerChatOnline()}
          alt=""
          role="presentation"
        />
      </div>
    </div>
  );
};

export default Zenvia;
